/**
 * Largely taken from analytics-web-react
 */

import { type UIAnalyticsEvent } from '@atlaskit/analytics-next';

import { extractFromEventContext } from './extract-data-from-event';

export const getSources = (event: UIAnalyticsEvent, contextName: string): any[] =>
	extractFromEventContext(['source'], event, false, contextName);
